import * as yup from "yup";

export const stringValidation = (t: (value: string) => string) =>
  yup.string().min(1).trim();

export const requiredStringValidation = (t: (value: string) => string) =>
  yup.string().min(1).trim().required(t("form.error.required"));
